// extracted by mini-css-extract-plugin
export var auto = "_4e-1";
export var spinner = "_4e-0";